import { parse, format, isValid } from 'date-fns';

/**
 * Converte data do formato brasileiro (DD/MM/YYYY) para ISO (YYYY-MM-DD)
 * @param {string} dateBR - Data no formato DD/MM/YYYY
 * @returns {string} Data no formato YYYY-MM-DD
 */
export const formatDateToISO = (dateBR) => {
    if (!dateBR) return '';

    // Se já está no formato ISO, retorna
    if (dateBR.match(/^\d{4}-\d{2}-\d{2}/)) {
        return dateBR.split('T')[0];
    }

    const parsed = parse(dateBR, 'dd/MM/yyyy', new Date());
    if (!isValid(parsed)) return '';

    return format(parsed, 'yyyy-MM-dd');
};

/**
 * Converte data do formato ISO (YYYY-MM-DD) para brasileiro (DD/MM/YYYY)
 * @param {string} dateISO - Data no formato YYYY-MM-DD ou YYYY-MM-DDTHH:mm:ss
 * @returns {string} Data no formato DD/MM/YYYY
 */
export const formatDateToBR = (dateISO) => {
    if (!dateISO) return '';

    // Se já está no formato brasileiro, retorna
    if (dateISO.match(/^\d{2}\/\d{2}\/\d{4}/)) {
        return dateISO;
    }

    // Remove a parte de tempo se houver
    const dateOnly = dateISO.split('T')[0];

    const parsed = parse(dateOnly, 'yyyy-MM-dd', new Date());
    if (!isValid(parsed)) return '';

    return format(parsed, 'dd/MM/yyyy');
};

/**
 * Valida se uma data está no formato brasileiro correto
 * @param {string} dateBR - Data no formato DD/MM/YYYY
 * @returns {boolean} True se a data é válida
 */
export const isValidBRDate = (dateBR) => {
    if (!dateBR) return false;

    const parsed = parse(dateBR, 'dd/MM/yyyy', new Date());
    return isValid(parsed);
};
